import { AvailableVehicleSearch } from '@/components/deal/available-vehicle-search';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Deal } from '@/models/registry';
import { observer } from 'mobx-react-lite';

export const NonMobileVehicleSwapDialog = observer(
  ({
    deal,
    openVehicleSwapDialog,
    setOpenVehicleSwapDialog,
  }: {
    deal: Deal;
    openVehicleSwapDialog: boolean;
    setOpenVehicleSwapDialog: (open: boolean) => void;
  }) => {
    return (
      <Dialog
        open={openVehicleSwapDialog}
        onOpenChange={setOpenVehicleSwapDialog}
        modal={true}
      >
        <DialogTitle className="hidden">
          Available Vehicle for Vehicle Swap
        </DialogTitle>
        <DialogContent
          onClickClose={() => {
            setOpenVehicleSwapDialog(false);
          }}
          className="!top-[0%] !mt-80"
        >
          <div className="flex flex-col">
            <div className="text-xs text-gray-500 p-2">Available Vehicle</div>
            <div className="mx-2">
              {deal.vehicle_listing && (
                <AvailableVehicleSearch
                  dealId={deal.id}
                  shortId={deal.short_id}
                  currentVehicleListingId={deal.vehicle_listing.id}
                  onConfirm={() => {
                    setOpenVehicleSwapDialog(false);
                  }}
                />
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  },
);
